var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBq({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.276H8.828A8.829 8.829 0 0 0 0 97.104v317.792a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828V97.104a8.83 8.83 0 0 0-8.829-8.828z",
    fill: "#41479b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.256 421.591L508.743 90.41c-1.53-1.273-3.425-2.134-5.571-2.134H8.828A8.829 8.829 0 0 0 0 97.104v317.792c0 2.729 1.311 5.076 3.256 6.695z",
    fill: "#f5f5f5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.779 88.276H8.828A8.829 8.829 0 0 0 0 97.104v138.442l224.779-147.27z",
    fill: "#ffe15a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.274 229.138c-4.006-26.736-25.089-47.82-51.826-51.826l-9.207-18.415-9.207 18.415c-26.736 4.006-47.819 25.088-51.826 51.826l-18.415 9.207 18.415 9.207c4.006 26.736 25.089 47.82 51.826 51.826l9.207 18.415 9.207-18.415c26.736-4.006 47.819-25.088 51.826-51.826l18.415-9.207-18.415-9.207zm-61.033 62.172c-29.252 0-52.965-23.713-52.965-52.965s23.713-52.965 52.965-52.965 52.965 23.713 52.965 52.965-23.713 52.965-52.965 52.965z",
    fill: "#464655"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M141.241 204.401l9.505 17.482 19.892-.51-10.388 16.972 10.388 16.972-19.892-.51-9.505 17.483-9.504-17.483-19.893.51 10.388-16.972-10.388-16.972 19.893.51z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBq);
export default __webpack_public_path__ + "static/media/bq.ba52e6671cdc18e6c09c02dac40c294c.svg";
export { ForwardRef as ReactComponent };